import Flatpickr from "stimulus-flatpickr";

// import the translation files and create a translation mapping
// import { French } from "flatpickr/dist/l10n/fr.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";
// import { english } from "flatpickr/dist/l10n/default.js";

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {

  initialize() {
    // sets your language (you can also set some global setting for all time pickers)
    this.config = {
      locale: Spanish
    }
  }

  connect() {
    //define locale and global flatpickr settings for all datepickers
    this.config = {
      locale: Spanish,
      // altInput: true,
      // showMonths: 2
    };

    super.connect();
  }

  // all flatpickr hooks are available as callbacks in your Stimulus controller
  change(selectedDates, dateStr, instance) {
    // console.log('the callback returns the selected dates', selectedDates)
    // console.log('but returns it also as a string', dateStr)
    // console.log('and the flatpickr instance', instance)

    // const form = this.element.closest("form")
    // automatically submit form when a date is selected
    // Rails.fire(form, "submit")
  }
}